export type TChartOfAccountsDTO = {
    coaId: number;
    name: string;
};

export const convertToChartOfAccountsDTO = (
    response: { coaId: number; name: string }[],
): TChartOfAccountsDTO[] => {
    return response.map(coa => ({
        coaId: coa.coaId,
        name: coa.name,
    }));
};
